/**
 * Rutas donde el aviso inline + CTAs de licencia sustituyen el toast LICENSE_BLOCKED.
 * Mirror de hubs de inicio de módulo (post-login) + Panel General + Configuración licencia.
 */
import { CONFIGURACION_DESPACHO_PATH } from "@/modules/config/configuracionRoutes";

export const LICENSE_CTA_HUB_PATHS = new Set([
  "/",
  "",
  "/datos-maestros",
  "/visor/inicio",
  "/laboral/inicio",
  "/tramites/inicio",
  "/despacho/inicio",
  "/disenador/inicio",
  CONFIGURACION_DESPACHO_PATH,
]);

/** @param {string} [pathname] */
export function isLicenseCtaHubPath(pathname = "") {
  const path = String(pathname || "").split("?")[0];
  return LICENSE_CTA_HUB_PATHS.has(path);
}

/** Panel General únicamente (sin hubs de módulo). */
export function isPanelGeneralPath(pathname = "") {
  const path = String(pathname || "").split("?")[0];
  return path === "/" || path === "";
}
